import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { env } from 'process';
import { OpenReplayService } from '../services/open-replay.service';

// This HttpConfigInterceptor is for Open Replay
@Injectable({providedIn: 'root'})
export class OpenReplayInterceptor implements HttpInterceptor {
  
  private env;
  
  constructor(private openReplayService: OpenReplayService) { 
    this.env = environment;
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!this.openReplayService.isEnabled()){
      return next.handle(request); 
    }
    
    const startTime = performance.now(); // Capture request start time
    
    //This function will be called with the response a few lines below
    const handleResponse = (request: HttpRequest<any>, response: HttpResponse<any>, event: string) => {
      const duration = performance.now() - startTime;
       //we forward our data to the service, which will create the custom event and send it
      this.openReplayService.sendEventToReplaySession(event, { 
        request, 
        response,
        duration:  duration.toFixed(2) + 'ms' 
      })
    }
    return next.handle(request).pipe(
      //filter out events that aren't http reponses
      filter( (event: any) => event instanceof HttpResponse),
      map( (resp: HttpResponse<any>) => { //for each response, call handleResponse
        handleResponse(request, resp, `${request.url}`)
        return resp
      }),
      map((event: HttpEvent<any>) => {
        return event;
      })
    );
  }
}